import styled from "styled-components";
import { Skeleton } from "antd";

const defaultBorderRadius = "6px";
const SkeletonStyled = styled(Skeleton)`
  &&& {
    .ant-skeleton-title {
      border-radius: ${defaultBorderRadius};
    }
    li {
      border-radius: ${defaultBorderRadius};
    }
  }
`;

export default SkeletonStyled;
